function getCollectionContent(handle) {
    const sectionId = document.querySelector('.custom-main-blog').id.replace('shopify-section-', '');
    let url;
    if (handle === 'all') {
        url = location.origin + `/blogs/{{ blog.handle }}/` + `?section_id=${sectionId}`;
    } else {
        url = location.origin + `/blogs/{{ blog.handle }}/tagged` + `/${handle}?section_id=${sectionId}`;
    }
    fetch(url).then(response => response.text()).then((responseText) => {
        const new_html = new DOMParser().parseFromString(responseText, 'text/html').querySelector('.custom_blogs_grid').innerHTML;
        document.querySelector('.custom_blogs_grid').innerHTML = new_html;
    })
}
document.querySelectorAll(".blog_filter_buttons_cont button").forEach((item) => {
    item.addEventListener('click', (e) => {
        getCollectionContent(item.dataset.handle);
        document.querySelector(".active-tag")?.classList.remove('active-tag');
        item.classList.add('active-tag');
    })
})

if (window.innerWidth < 770) {
    const generateDotBtns = (dots, embla) => {
        const template = document.getElementById("embla-dot-template").innerHTML;
        dots.innerHTML = embla.scrollSnapList().reduce(acc => acc + template, "");

        return [].slice.call(dots.querySelectorAll(".embla__dot"));
    };

    const selectDotBtn = (dotsArray, embla) => () => {
        const previous = embla.previousScrollSnap();
        const selected = embla.selectedScrollSnap();

        dotsArray[previous].classList.remove("is-selected");
        dotsArray[selected].classList.add("is-selected");
    };

    const setupDotBtns = (dotsArray, embla) => {
        dotsArray.forEach((dotNode, i) => {
            dotNode.addEventListener("click", () => embla.scrollTo(i), false);
        });
    };

    const reviewsEmblaNode = document.querySelector('.embla.reviews-carousel')
    const options = { loop: false, align: "start", }

    const reviewsEmbla = EmblaCarousel(reviewsEmblaNode, options);
    const reviewDots = reviewsEmblaNode.querySelector('.embla__dots')

    const reviewDotsArray = generateDotBtns(reviewDots, reviewsEmbla);
    const setReviewSelectedDotBtn = selectDotBtn(reviewDotsArray, reviewsEmbla);

    setupDotBtns(reviewDotsArray, reviewsEmbla);

    reviewsEmbla.on("select", setReviewSelectedDotBtn);
    reviewsEmbla.on("init", setReviewSelectedDotBtn);
}